import {HttpClient} from '@angular/common/http';
import {TranslateLoader} from '@ngx-translate/core';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import * as lodash from 'lodash';

/**
 * Loader capable de charger plusieurs fichiers de traduction
 * Celui de base ne pouvait en charger qu'un
 *
 * Utile car on a le fichier de traduction du module et celui pour header/footer
 */
export class MultiTranslateHttpLoader implements TranslateLoader {

    constructor(private http: HttpClient,
                public resources: Array<{ prefix: string, suffix: string }>) {
    }

    /**
     * Gets the translations from the server
     *
     * Make an http call for each ressources passed in constructor
     * Then regroup results inside one object
     *
     * @param lang The lang to use for the translation
     * @returns {any} An object containing all the translations for the lang
     */
    public getTranslation(lang: string): any {
        return Observable.forkJoin(this.resources.map(config => {
            return this.http.get(`${config.prefix}${lang}${config.suffix}`);
        })).map(responses => {
            const translateDatas = responses.reduce((tradAcumul, tradObject) => {
                return lodash.merge(tradAcumul, tradObject);
            });
            return translateDatas;
        });
    }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/i18n/MultiTranslateHttpLoader.ts